import { action } from 'satcheljs';

export const updateSelectedCalendarIdsInStore = action(
    'UPDATE_SELECTED_TIME_PANEL_CALENDARIDS_IN_STORE',
    (calendarIds: string[], userIdentity: string) => ({ calendarIds, userIdentity })
);
